import React from 'react';
import LegalDocumentBody from '../LegalDocumentBody';

type Props = {
    setActiveRightTab?: Function;
};

export default function OrderExecutionPolicy({ setActiveRightTab }: Props) {
    return <LegalDocumentBody titleKey="order-execution-policy" bodyKey="order-execution-policy-body" setActiveRightTab={setActiveRightTab} />;
}
